import { useState, useCallback } from "react";
import axios from "axios";

import App, { BASE_URL, BASE_URL2 } from "./cookies.config";

function useRequest(
  { api = 1, path, method = "get", search },
  { onCompleted = (response) => {}, onError = (error) => {} } = {}
) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(undefined);
  const [error, setError] = useState(undefined);

  const refetch = useCallback((variables = {}) => {
    setLoading(true);
    if (method === "get") {
      axios
        .get(api === 1 ? BASE_URL : BASE_URL2 + path, {
          headers: { token: App.getCipher() },
        })
        .then((response) => {
          setResponse(response.data);
          setLoading(false);
          setError(undefined);
          onCompleted && onCompleted(response);
        })
        .catch((error) => {
          setResponse(undefined);
          setLoading(false);
          setError(error);
          onError && onError(error);
        });
    } else {
      axios
        .post(api === 1 ? BASE_URL : BASE_URL2 + path, variables, {
          headers: { token: App.getCipher() },
        })
        .then((response) => {
          setResponse(response.data);
          setLoading(false);
          setError(undefined);
          onCompleted && onCompleted(response);
        })
        .catch((error) => {
          setResponse(undefined);
          setLoading(false);
          setError(error);
          onError && onError(error);
        });
    }
  }, []);

  const makeRequest = useCallback((variables = {}) => {
    console.log(api === 1 ? BASE_URL : BASE_URL2 + path);
    setLoading(true);
    if (method === "get") {
      axios
        .get(api === 1 ? BASE_URL + path : BASE_URL2 + path, {
          headers: { token: App.getCipher() },
        })
        .then((response) => {
          setResponse(response.data);
          setLoading(false);
          setError(undefined);
          onCompleted && onCompleted(response);
        })
        .catch((error) => {
          setResponse(undefined);
          setLoading(false);
          setError(error);
          onError && onError(error);
        });
    } else {
      // console.log(path);
      axios
        .post(api === 1 ? BASE_URL : BASE_URL2 + path, variables, {
          headers: { token: App.getCipher() },
        })
        .then((response) => {
          setResponse(response.data);
          setLoading(false);
          setError(undefined);
          onCompleted && onCompleted(response);
        })
        .catch((error) => {
          setResponse(undefined);
          setLoading(false);
          setError(error);
          onError && onError(error);
        });
    }
  }, []);

  return [
    makeRequest,
    { loading, data: response, error, refetch: () => refetch() },
  ];
}

export default useRequest;
